import React, { useState, useEffect, useRef } from "react";
import {
  ResponsiveContainer,
  ComposedChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  Scatter
} from "recharts";
import { motion } from "framer-motion";
import { fetchStockHistory } from "../models/marketsService"; // ✅ Import API call
import useIsMobile from "../components/useIsMobile";
import image_toggle from "../assets/Toggle.png";
import marketDataJSON from "../models/marketDays.json"; // ✅ Import JSON file
import liveUpdatesJSON from "../models/liveUpdates.json"; // ✅ Import separate live updates



const MARKET_TICKERS = {
  dow: "DJI",
  sp500: "SPX",
  nasdaq: "IXIC",
};

// ✅ Convert times to timestamps for accurate X-Axis scaling
const marketOpen = new Date();
marketOpen.setHours(9, 30, 0, 0); // 9:30 AM

const marketClose = new Date();
marketClose.setHours(12, 0, 0, 0); // 11:00 AM

// const marketData = [
//   { time: new Date().setHours(9, 30, 0, 0), dow: 4290, sp500: 3985, nasdaq: 3610 },
//   { time: new Date().setHours(9, 40, 0, 0), dow: 4292, sp500: 3990, nasdaq: 3620 },
//   { time: new Date().setHours(9, 50, 0, 0), dow: 4295, sp500: 3995, nasdaq: 3625 },
//   { time: new Date().setHours(10, 0, 0, 0), dow: 4300, sp500: 4000, nasdaq: 3630 },
//   { time: new Date().setHours(10, 10, 0, 0), dow: 4310, sp500: 4010, nasdaq: 3645 },
//   { time: new Date().setHours(10, 20, 0, 0), dow: 4315, sp500: 4015, nasdaq: 3650 },
//   { time: new Date().setHours(10, 30, 0, 0), dow: 4320, sp500: 4020, nasdaq: 3660 },
//   { time: new Date().setHours(10, 40, 0, 0), dow: 4325, sp500: 4030, nasdaq: 3675 },
//   { time: new Date().setHours(10, 50, 0, 0), dow: 4330, sp500: 4035, nasdaq: 3680 },
//   { time: new Date().setHours(11, 0, 0, 0), dow: 4335, sp500: 4040, nasdaq: 3685 },
//   { time: new Date().setHours(11, 10, 0, 0), dow: 4340, sp500: 4045, nasdaq: 3690 },
//   { time: new Date().setHours(11, 20, 0, 0), dow: 4345, sp500: 4050, nasdaq: 3695 },
//   { time: new Date().setHours(11, 30, 0, 0), dow: 4350, sp500: 4055, nasdaq: 3700 },
//   { time: new Date().setHours(11, 40, 0, 0), dow: 4355, sp500: 4060, nasdaq: 3705 },
//   { time: new Date().setHours(11, 50, 0, 0), dow: 4360, sp500: 4065, nasdaq: 3710 },
//   { time: new Date().setHours(12, 0, 0, 0), dow: 4365, sp500: 4070, nasdaq: 3715 }
// ];
const marketData = [
  { time: new Date().setHours(9, 30, 0, 0), dow: 4190, sp500: 3885, nasdaq: 3610 },
  { time: new Date().setHours(9, 35, 0, 0), dow: 4185, sp500: 3980, nasdaq: 3605 },
  { time: new Date().setHours(9, 40, 0, 0), dow: 4100, sp500: 3995, nasdaq: 3620 },
  { time: new Date().setHours(9, 45, 0, 0), dow: 4175, sp500: 3975, nasdaq: 3590 },
  { time: new Date().setHours(9, 50, 0, 0), dow: 4195, sp500: 3987, nasdaq: 3612 },
  { time: new Date().setHours(9, 55, 0, 0), dow: 4210, sp500: 4005, nasdaq: 3635 },
  { time: new Date().setHours(10, 0, 0, 0), dow: 4225, sp500: 4020, nasdaq: 3650 },
  { time: new Date().setHours(10, 5, 0, 0), dow: 4215, sp500: 4005, nasdaq: 3640 },
  { time: new Date().setHours(10, 10, 0, 0), dow: 4300, sp500: 3980, nasdaq: 3725 },
  { time: new Date().setHours(10, 15, 0, 0), dow: 4285, sp500: 3975, nasdaq: 3710 },
  { time: new Date().setHours(10, 20, 0, 0), dow: 4298, sp500: 3985, nasdaq: 3720 },
  { time: new Date().setHours(10, 25, 0, 0), dow: 4310, sp500: 4000, nasdaq: 3738 },
  { time: new Date().setHours(10, 30, 0, 0), dow: 4328, sp500: 4015, nasdaq: 3755 },
  { time: new Date().setHours(10, 35, 0, 0), dow: 4340, sp500: 4030, nasdaq: 3670 },
  { time: new Date().setHours(10, 40, 0, 0), dow: 4325, sp500: 4010, nasdaq: 3550 },
  { time: new Date().setHours(10, 45, 0, 0), dow: 4210, sp500: 3995, nasdaq: 3635 },
  { time: new Date().setHours(10, 50, 0, 0), dow: 4295, sp500: 3980, nasdaq: 3620 },
  { time: new Date().setHours(10, 55, 0, 0), dow: 4280, sp500: 3965, nasdaq: 3605 },
  { time: new Date().setHours(11, 0, 0, 0), dow: 4270, sp500: 3950, nasdaq: 3590 },
  { time: new Date().setHours(11, 5, 0, 0), dow: 4285, sp500: 3965, nasdaq: 3605 },
  { time: new Date().setHours(11, 10, 0, 0), dow: 4298, sp500: 3980, nasdaq: 3622 },
  { time: new Date().setHours(11, 15, 0, 0), dow: 4312, sp500: 3995, nasdaq: 3638 },
  { time: new Date().setHours(11, 20, 0, 0), dow: 4325, sp500: 4010, nasdaq: 3655 },
  { time: new Date().setHours(11, 25, 0, 0), dow: 4340, sp500: 4025, nasdaq: 3772 },
  { time: new Date().setHours(11, 30, 0, 0), dow: 4325, sp500: 4010, nasdaq: 3758 },
  { time: new Date().setHours(11, 35, 0, 0), dow: 4310, sp500: 3895, nasdaq: 3642 },
  { time: new Date().setHours(11, 40, 0, 0), dow: 4295, sp500: 3880, nasdaq: 3625 },
  { time: new Date().setHours(11, 45, 0, 0), dow: 4280, sp500: 3965, nasdaq: 3610 },
  { time: new Date().setHours(11, 50, 0, 0), dow: 4265, sp500: 3950, nasdaq: 3595 },
  { time: new Date().setHours(11, 55, 0, 0), dow: 4250, sp500: 3935, nasdaq: 3580 },
  { time: new Date().setHours(12, 0, 0, 0), dow: 4265, sp500: 3950, nasdaq: 3595 },
  { time: new Date().setHours(12, 5, 0, 0), dow: 4280, sp500: 3965, nasdaq: 3610 },
  { time: new Date().setHours(12, 10, 0, 0), dow: 4295, sp500: 3880, nasdaq: 3625 },
  { time: new Date().setHours(12, 15, 0, 0), dow: 4310, sp500: 3995, nasdaq: 3640 },
  { time: new Date().setHours(12, 20, 0, 0), dow: 4325, sp500: 4010, nasdaq: 3655 },
  { time: new Date().setHours(12, 25, 0, 0), dow: 4340, sp500: 4025, nasdaq: 3670 },
  { time: new Date().setHours(12, 30, 0, 0), dow: 4425, sp500: 4010, nasdaq: 3655 },
  { time: new Date().setHours(12, 35, 0, 0), dow: 4310, sp500: 3995, nasdaq: 3640 },
  { time: new Date().setHours(12, 40, 0, 0), dow: 4295, sp500: 3980, nasdaq: 3625 },
  { time: new Date().setHours(12, 45, 0, 0), dow: 4280, sp500: 3965, nasdaq: 3610 }
];


const liveUpdates = [
  { time: marketOpen.getTime(), headline: "Markets open mixed as investors eye inflation data" },
  { time: new Date(marketOpen.getTime() + 30 * 60 * 1000).getTime(), headline: "Why Nvidia Needs to Appeal to a Bigger Crowd" },
  { time: new Date(marketOpen.getTime() + 100 * 60 * 1000).getTime(), headline: "Apple Shares Fall After Berkshire Hathaway Reports It Sold Stock" },
  { time: new Date(marketOpen.getTime() + 110 * 60 * 1000).getTime(), headline: "Gold hits three-month high on safe-haven demand" },
  { time: new Date(marketOpen.getTime() + 125 * 60 * 1000).getTime(), headline: "New York Times Stock Slides Gas Tech Workers Strike" },
  { time: new Date(marketOpen.getTime() + 140 * 60 * 1000).getTime(), headline: "Stocks to Watch Thursday: DocuSign, Crown Castle, Telsa, Rubrik" },
  { time: marketClose.getTime(), headline: "Nvidia to Replace Intel in Dow Jones Industrial Average" },
];



// ✅ Apply merge

const MarketGraph = (selectedDate) => {
  const [hoveredData, setHoveredData] = useState(marketData[0]);
  const [selectedTime, setSelectedTime] = useState(marketData[0].time);
  const [liveUpdates, setLiveUpdates] = useState([]);
  const [tooltipX, setTooltipX] = useState(0);
  const [marketDay, setMarketDay] = useState([]);

  const mergeLiveUpdates = (marketData, liveUpdates) => {
    if(marketData) {
      console.log("Merging Market Data: " + marketData);
    return marketData.map((dataPoint) => {
      const matchingUpdate = liveUpdates.find((update) => update.time === dataPoint.time);
      return { ...dataPoint, headline: matchingUpdate ? matchingUpdate.headline : null };
    });
    }
  };

  const mergedMarketData = mergeLiveUpdates(marketDay, liveUpdates);
  
  useEffect(() => {
    const selectedKey = selectedDate?.selectedDate?.selectedDate; // Ensure safe access
  
    if (selectedKey && marketDataJSON[selectedKey]) {
      setMarketDay(marketDataJSON[selectedKey]); // ✅ Load data for selected date
      
      // ✅ Get the selected date's live updates
      const selectedLiveUpdates = liveUpdatesJSON[selectedKey] || [];
      setLiveUpdates(selectedLiveUpdates);
    } else {
      setMarketDay([]); // ✅ Clear data if no match
    }
  }, [selectedDate]);
  
  
  const updatesContainerRef = useRef(null);
  const isMobile = useIsMobile(); // ✅ Detect mobile device


  const handleMouseMove = (e) => {
    
    if (e && e.activePayload) {
      const newData = e.activePayload[0]?.payload; // ✅ Use first payload for accuracy
      if (newData) {
        setHoveredData(newData);
        setSelectedTime(newData.time);
        setTooltipX(e.chartX);

        const closestUpdate = liveUpdates.reduce((prev, curr) => 
          Math.abs(curr.time - newData.time) < Math.abs(prev.time - newData.time) ? curr : prev
        );
  
        // ✅ Auto-scroll to selected story
        if (updatesContainerRef.current) {
          const updateIndex = liveUpdates.findIndex(update => update.time === closestUpdate.time);
          const storyElement = updatesContainerRef.current.children[updateIndex];
    
          if (storyElement) {
            updatesContainerRef.current.scrollTo({
              left: storyElement.offsetLeft - 20, // ✅ Offset for padding
              behavior: "smooth",
            });
          }
        }
      }
    }
  };

  const renderCustomDot = (props) => {
    const { cx, cy, payload } = props;
    const isSelected = selectedTime === payload.time;
    if(payload.headline === null) return
    return (
      <circle
        cx={cx}
        cy={170}
        r={4}
        fill={isSelected ? "red" : "white"}
        stroke="red"
        strokeWidth={isSelected ? 3 : 2}
      />
    );
  };

  let lastScrollTime = 0;
  

  const handleStoryScroll = () => {
    if (!updatesContainerRef.current || isHoveringGraph) return;
  
    const scrollX = updatesContainerRef.current.scrollLeft;
    const containerWidth = updatesContainerRef.current.scrollWidth;
    const viewportWidth = updatesContainerRef.current.clientWidth;
    const scrollProgress = scrollX / (containerWidth - viewportWidth);
  
    // ✅ Step 1: Get the closest time index
    const closestTimeIndex = Math.round(scrollProgress * (marketData.length - 1));
    const closestTime = marketData[closestTimeIndex]?.time;
  
    // ✅ Step 2: Add a padding range (example: ±15 minutes)
    const paddingRange = 15 * 60 * 1000; // 15 minutes in milliseconds
    let bestMatch = closestTime;
    
    for (const update of liveUpdates) {
      if (Math.abs(update.time - closestTime) <= paddingRange) {
        bestMatch = update.time; // ✅ Choose the nearest live update within the range
        break; // Stop once we find a good match
      }
    }
  
    // ✅ Step 3: Apply the best-matching time
    if (bestMatch && bestMatch !== selectedTime) {
      setSelectedTime(bestMatch);
      setHoveredData(marketData.find((d) => d.time === bestMatch));
    }
  };
  
  

  const [isHoveringGraph, setIsHoveringGraph] = useState(false);

const handleGraphEnter = () => setIsHoveringGraph(true);
const handleGraphLeave = () => setIsHoveringGraph(false);

  
  // ✅ Attach optimized listener
  useEffect(() => {
    if (updatesContainerRef.current) {
      updatesContainerRef.current.addEventListener("scroll", handleStoryScroll);
    }
    return () => {
      if (updatesContainerRef.current) {
        updatesContainerRef.current.removeEventListener("scroll", handleStoryScroll);
      }
    };
  }, [isHoveringGraph]); // ✅ Reacts to `isHoveringGraph`
  
  

  // ✅ Custom Tooltip with Dynamic Left Position
  const CustomTooltip = ({ active, payload, coordinate }) => {
    if (active && payload && payload.length) {
      return (
        <div style={{
          position: "absolute",
          left: `${coordinate.x}px`, // ✅ Align with cursor line
          top: "-12px",
          width: "60px",
          textAlign: "center",
          background: "black",
          color: "white",
          padding: "6px 0px",
          borderRadius: "4px",
          fontSize: "8px",
          fontWeight: "500",
          transform: "translateX(-110%)",
          pointerEvents: "none",
          fontFamily: "Retina"
        }}>
          <p>{selectedDate?.selectedDate?.selectedDate === "TH" ? "TODAY" : selectedDate?.selectedDate?.selectedDate} {new Date(payload[0].payload.time  + 4 * 60 * 60 * 1000).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false })}</p>
          <div style={{
          width: "6px",
          height: "6px",
          borderRadius: "50%",
          backgroundColor: "black",
          position: "absolute",
          top: "10px",
          left: "calc(100% + 3px)", // ✅ 20px to the right of tooltip
        }} />
        
        </div>
      );
    }
    return null;
  };

  const handleGraphTouch = (event) => {
    event.stopPropagation(); // ✅ Prevent scrolling stories
    setIsHoveringGraph(true);
  };
  
  const handleGraphTouchEnd = () => {
    setTimeout(() => setIsHoveringGraph(false), 200); // ✅ Slight delay to avoid glitches
  };
  

  const [yMin, setYMin] = useState(3500); // Default fallback
  const [yMax, setYMax] = useState(4500); // Default fallback
  
  useEffect(() => {
    if (marketDay.length > 0) {
      const minValue = Math.min(...marketDay.flatMap(d => [d.dow, d.sp500, d.nasdaq])) * 0.99; // 3% padding below
      const maxValue = Math.max(...marketDay.flatMap(d => [d.dow, d.sp500, d.nasdaq])) * 1.01; // 3% padding above
  
      setYMin(minValue);
      setYMax(maxValue);
    } else {
      setYMin(3500); // Reset to default if no data
      setYMax(4500);
    }
  }, [marketDay]); // ✅ Runs when `marketDay` updates
  
  

const scatterData = mergedMarketData
  .filter((d) => d.headline) // ✅ Only include points that have headlines
  .map((update) => ({
    time: update.time,
    value: update.sp500 ?? update.dow ?? update.nasdaq ?? yMin, // ✅ Use an actual Y-value
  }));
  
  const marketTimes = marketDay.length > 0 
  ? [marketDay[0].time, marketDay[marketDay.length - 1].time] 
  : [marketOpen.getTime(), marketClose.getTime()]; // Default fallback

  return (
    <div style={{ display: "flex", flexDirection: "column", width: "100%" }}>
      {/* <h2 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "16px" }}>MARKET TODAY</h2> */}

      <div style={{
        display: "flex",
        justifyContent: "space-between"
      }}>
      <div className="region-selector" style={{ display: "flex", gap: "10px", marginBottom: "16px" }}>
        {["US", "Europe", "Asia"].map((region) => (
          <button className={region} key={region} style={{
            background: region === "US" ? "#ddd" : "transparent",
          }}>
            {region}
          </button>
        ))}
      </div>
        <img src="figma-toggle" src={image_toggle}
        style={{
          height: "32px"

        }}
        ></img>
      </div>

      <div className="marketKey" style={{ display: "flex", justifyContent: "space-between", marginBottom: "16px" }}>
        <div className="marketKey-item">
            <div className="indicator" style={{ backgroundColor: "#6A9FB5"}}></div>
            <div className="titlePrice">
          <span >Dow Industrial</span>
          <p>{hoveredData.dow.toFixed(2)}</p>
          </div>
        </div>
        <div className="marketKey-item">
            <div className="indicator" style={{ backgroundColor: "#4355A1"}}></div>
            <div className="titlePrice">
          <span >S&P 500</span>
          <p>{hoveredData.sp500.toFixed(2)}</p>
          </div>
        </div>
        <div className="marketKey-item">
            <div className="indicator" style={{ backgroundColor: "#A8A8D9"}}></div>
            <div className="titlePrice">
          <span >Nasdaq Composite</span>
          <p>{hoveredData.nasdaq.toFixed(2)}</p>
          </div>
        </div>
      </div>

      <ResponsiveContainer 
        width="100%" 
        height={200} 
        onMouseEnter={handleGraphEnter} 
        onMouseLeave={handleGraphLeave}
      >
      <ComposedChart 
      margin={{ left: -32, right: 6 }} data={mergedMarketData} onMouseMove={handleMouseMove}
      onMouseEnter={() => setIsHoveringGraph(true)}
      onMouseLeave={() => setIsHoveringGraph(false)}
      onTouchStart={handleGraphTouch}
      onTouchMove={handleGraphTouch} // ✅ If finger moves, keep scrolling locked
      onTouchEnd={handleGraphTouchEnd}
      style={{ pointerEvents: "auto" }}
      >
      <CartesianGrid strokeDasharray="3 0" horizontal={true} vertical={false} stroke="#EBEBEB" strokeWidth={0.5} />
      <XAxis
          tickLine={false} // ✅ Removes tick lines
          dataKey="time"
          type="number"
          tick={{ fontSize: 8, fontFamily: "Retina", fontWeight: "400", fill: "#6F6F6F" }} // ✅ Customize text
          domain={marketTimes}
          tickFormatter={(time) => new Date(time + 4 * 60 * 60 * 1000).toLocaleTimeString([], { hour: "numeric", hour12: true }).toLowerCase()}
          minTickGap={16}
        />
        <YAxis 
          tick={{ fontSize: 8, fontFamily: "Retina", fontWeight: "400", fill: "#6F6F6F" }} // ✅ Customize text
          axisLine={false} // ✅ Removes Y-axis line
          tickLine={false} // ✅ Removes Y-axis tick marks
          domain={[yMin, yMax]} />
        <Tooltip 
          content={<CustomTooltip/>}
          cursor={{ stroke: "black", strokeWidth: 1 }} // ✅ Make hover line black
             />

        {/* ✅ Scatter now directly references mergedMarketData */}
        <Scatter name="Live Updates" data={mergedMarketData} dataKey="value" fill="red" shape={renderCustomDot} />

        <Line type="monotone" dataKey="dow" stroke="#6A9FB5" strokeWidth={2} dot={false}/>
        <Line type="monotone" dataKey="sp500" stroke="#4355A1" strokeWidth={2} dot={false}/>
        <Line type="monotone" dataKey="nasdaq" stroke="#A8A8D9" strokeWidth={2} dot={false}/>
      </ComposedChart>
    </ResponsiveContainer>


      {/* ✅ Re-Added Stories Section */}
      <motion.div className="liveUpdates-container" ref={updatesContainerRef} style={{ overflowX: "auto", whiteSpace: "nowrap", display: "flex", gap: "10px", marginTop: "20px" }}>
        {liveUpdates.map((update) => (
          <motion.div className="liveUpdate" key={update.time} 
          // style={{ padding: "12px", background: update.time === selectedTime ? "#F0F0F0" : "transparent" }}
          >
            <p className="updateTime" style={{color: update.time === selectedTime ? "red" : "gray"}}>• {new Date(update.time  + 4 * 60 * 60 * 1000).toLocaleTimeString([], { hour: "numeric", minute: "numeric", hour12: true }).toLowerCase()}</p>
            <p className="updateHeadline">{update.headline}</p>
          </motion.div>
        ))}
      </motion.div>
      <div className="view-all">View All Updates</div>
    </div>
  );
};

export default MarketGraph;
